import type { KambiBetOffer, KambiEvent } from '@mobi/api-types/kambi'
import { simpleFetch } from '@core/Utils/fetch/simpleFetch'

export const getKambiBetOffersByIds = ({ betOfferIds }: { betOfferIds: number[] }) =>
  simpleFetch<KambiBetOffersByIdsResponse>(
    `${window._kc.apiOfferingBaseUrl}betoffer/${betOfferIds.join(',')}`
  )

export const getKambiEventOutcomePricing = ({
  eventId,
  outcomeIds,
}: {
  eventId: KambiEvent['id']
  outcomeIds: KambiBetOffer['outcomes'][0]['id'][]
}) => {
  const base = window._kc.apiOfferingBaseUrl
  const query = '?excludeBetOffers=true&lang=en_AU&market=AU'
  return simpleFetch<EventOutcomePricingResponse>(
    `${base}onDemandPricing/event/${eventId}/outcome/${outcomeIds.join(',')}${query}`
  )
}

// =====
// Types
// =====

type KambiBetOffersByIdsResponse = {
  betOffers: KambiBetOffer[]
  events: KambiEvent[]
  /** Represents a pre pack @todo determine if required */
  prePacks: never
  range: {
    start: number
    size: number
    total: number
    hasNext: boolean
  }
}

type EventOutcomePricingResponse = {
  /** The event identifier of the on-demand-pricing bet */
  eventId: number
  /** Outcome identifiers that have been selected and is part of the pricing.
   *  Will be empty when there is no selection */
  selectedOutcomeIds: number[]
  selectedOdds: {
    /** Odds. See general documentation for format */
    decimal: number
    american: string
    fractional: string
  }
  /** Outcome identifiers within this event that might be included in an on-demand combination */
  combinableOutcomeIds: number[]
}
